var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "el-dialog",
    {
      staticClass: "page-dialog dialog-fixed-height",
      attrs: {
        title: _setup.dialogTitle,
        visible: _vm.visible,
        width: "560px",
        "close-on-click-modal": false,
      },
      on: { close: _setup.handleClose },
    },
    [
      _c(
        "div",
        { staticClass: "dialog-content" },
        [
          _c(
            "el-form",
            {
              ref: "formRef",
              staticClass: "tier-form",
              attrs: {
                model: _setup.localForm,
                rules: _setup.formRules,
                "label-position": "right",
                "label-width": "120px",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "存款档位", prop: "amountYuan" } },
                [
                  _c("el-input-number", {
                    staticClass: "input-number-sm",
                    attrs: { min: 0, placeholder: "例: 1000" },
                    model: {
                      value: _setup.localForm.amountYuan,
                      callback: function ($$v) {
                        _vm.$set(_setup.localForm, "amountYuan", $$v)
                      },
                      expression: "localForm.amountYuan",
                    },
                  }),
                  _c("span", { staticClass: "form-unit" }, [
                    _vm._v(_vm._s(_setup.config.currency)),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "真金稽核倍数", prop: "multiplier" } },
                [
                  _c("el-input-number", {
                    staticClass: "input-number-sm",
                    attrs: { min: 0, placeholder: "0" },
                    model: {
                      value: _setup.localForm.multiplier,
                      callback: function ($$v) {
                        _vm.$set(_setup.localForm, "multiplier", $$v)
                      },
                      expression: "localForm.multiplier",
                    },
                  }),
                  _c("span", { staticClass: "form-unit" }, [_vm._v("倍")]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "赠送类型", prop: "bonus_type" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _setup.localForm.bonus_type,
                        callback: function ($$v) {
                          _vm.$set(_setup.localForm, "bonus_type", $$v)
                        },
                        expression: "localForm.bonus_type",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("比例赠送"),
                      ]),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("固定金额"),
                      ]),
                      _c("el-radio", { attrs: { label: 3 } }, [
                        _vm._v("无赠送"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _setup.localForm.bonus_type === 1
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { label: "赠送方式", prop: "bonus_method" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _setup.localForm.bonus_method,
                              callback: function ($$v) {
                                _vm.$set(_setup.localForm, "bonus_method", $$v)
                              },
                              expression: "localForm.bonus_method",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v("固定"),
                            ]),
                            _c("el-radio", { attrs: { label: 2 } }, [
                              _vm._v("范围内随机"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "赠送比例", prop: "bonus_ratio_min" } },
                      [
                        _c(
                          "span",
                          { staticClass: "ratio-inputs" },
                          [
                            _c("el-input-number", {
                              staticClass: "input-number-sm",
                              attrs: {
                                min: 0,
                                max: 100,
                                placeholder: "最小值",
                              },
                              model: {
                                value: _setup.localForm.bonus_ratio_min,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _setup.localForm,
                                    "bonus_ratio_min",
                                    $$v
                                  )
                                },
                                expression: "localForm.bonus_ratio_min",
                              },
                            }),
                            _setup.localForm.bonus_method === 2
                              ? [
                                  _c("span", { staticClass: "ratio-sep" }, [
                                    _vm._v("-"),
                                  ]),
                                  _c("el-input-number", {
                                    staticClass: "input-number-sm",
                                    attrs: {
                                      min: 0,
                                      max: 100,
                                      placeholder: "最大值",
                                    },
                                    on: {
                                      blur: () =>
                                        _setup.formRef &&
                                        _setup.formRef.validateField(
                                          "bonus_ratio_min"
                                        ),
                                    },
                                    model: {
                                      value: _setup.localForm.bonus_ratio_max,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _setup.localForm,
                                          "bonus_ratio_max",
                                          $$v
                                        )
                                      },
                                      expression: "localForm.bonus_ratio_max",
                                    },
                                  }),
                                ]
                              : _vm._e(),
                            _c("span", { staticClass: "ratio-unit" }, [
                              _vm._v("%"),
                            ]),
                          ],
                          2
                        ),
                      ]
                    ),
                  ]
                : _setup.localForm.bonus_type === 2
                ? _c(
                    "el-form-item",
                    {
                      attrs: { label: "赠送金额", prop: "bonus_fixed_amount" },
                    },
                    [
                      _c("el-input-number", {
                        staticClass: "input-number-sm",
                        attrs: { min: 0, placeholder: "0" },
                        model: {
                          value: _setup.localForm.bonus_fixed_amountYuan,
                          callback: function ($$v) {
                            _vm.$set(
                              _setup.localForm,
                              "bonus_fixed_amountYuan",
                              $$v
                            )
                          },
                          expression: "localForm.bonus_fixed_amountYuan",
                        },
                      }),
                      _c("span", { staticClass: "form-unit" }, [
                        _vm._v(_vm._s(_setup.config.currency)),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "赏金稽核倍数", prop: "bonus_multiple" } },
                [
                  _c("el-input-number", {
                    staticClass: "input-number-sm",
                    attrs: { min: 0, placeholder: "0" },
                    model: {
                      value: _setup.localForm.bonus_multiple,
                      callback: function ($$v) {
                        _vm.$set(_setup.localForm, "bonus_multiple", $$v)
                      },
                      expression: "localForm.bonus_multiple",
                    },
                  }),
                  _c("span", { staticClass: "form-unit" }, [_vm._v("倍")]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态", prop: "status" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _setup.localForm.status,
                        callback: function ($$v) {
                          _vm.$set(_setup.localForm, "status", $$v)
                        },
                        expression: "localForm.status",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("禁用")]),
                      _c("el-radio", { attrs: { label: 2 } }, [_vm._v("启用")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "form-item-vips",
                  attrs: { label: "适用对象", prop: "vips" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "vips-wrap" },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { value: _setup.isAllVipChecked },
                          on: { change: _setup.handleAllVipChange },
                        },
                        [_vm._v("全选")]
                      ),
                      _c(
                        "el-checkbox-group",
                        {
                          staticClass: "vips-group",
                          model: {
                            value: _setup.localForm.vips,
                            callback: function ($$v) {
                              _vm.$set(_setup.localForm, "vips", $$v)
                            },
                            expression: "localForm.vips",
                          },
                        },
                        _vm._l(_setup.vipOptions, function (item) {
                          return _c(
                            "el-checkbox",
                            { key: item.value, attrs: { label: item.value } },
                            [_vm._v(" " + _vm._s(item.label) + " ")]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _setup.handleClose } }, [
            _vm._v("取消"),
          ]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _setup.loading },
              on: { click: _setup.handleConfirm },
            },
            [_vm._v("确认")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }